var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 101,
    viewBox: "0 0 137 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3059 92.5343C13.3824 98.1246 19.9117 100.524 19.9117 100.524C19.9117 100.524 21.4531 93.8605 18.3767 88.2703C15.3002 82.68 8.77092 80.2803 8.77092 80.2803C8.77092 80.2803 7.22951 86.9441 10.3059 92.5343Z",
    fill: "#2F2E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4203 90.6948C17.9746 93.969 20.1137 100.472 20.1137 100.472C20.1137 100.472 13.2476 101.667 7.69336 98.3932C2.13912 95.119 0 88.6156 0 88.6156C0 88.6156 6.8661 87.4206 12.4203 90.6948Z",
    fill: "#FF6363"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6216 89.9745H31.0093V89.5614H89.1998V69.523H35.9367L33.3492 64.2412L33.7294 64.0625L36.202 69.1097H89.6216V89.9745Z",
    fill: "#2F2E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8104 100.097C41.2556 100.097 43.2379 98.1545 43.2379 95.7586C43.2379 93.3627 41.2556 91.4204 38.8104 91.4204C36.3651 91.4204 34.3828 93.3627 34.3828 95.7586C34.3828 98.1545 36.3651 100.097 38.8104 100.097Z",
    fill: "#3F3D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4534 100.097C84.8987 100.097 86.881 98.1545 86.881 95.7586C86.881 93.3627 84.8987 91.4204 82.4534 91.4204C80.0082 91.4204 78.0259 93.3627 78.0259 95.7586C78.0259 98.1545 80.0082 100.097 82.4534 100.097Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.897 6.30909C135.411 6.30909 136.638 5.10673 136.638 3.62354C136.638 2.14035 135.411 0.937988 133.897 0.937988C132.384 0.937988 131.156 2.14035 131.156 3.62354C131.156 5.10673 132.384 6.30909 133.897 6.30909Z",
    fill: "#3F3D56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8907 62.7056H30.0101L15.7551 17.0513H110.571L110.485 17.3199L95.8907 62.7056ZM30.3221 62.2925H95.5814L109.996 17.4644H16.325L30.3221 62.2925Z",
    fill: "#2F2E41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.752 12.9729L111.345 12.8669L114.127 2.59082H130.313V3.0041H114.452L111.752 12.9729Z",
    fill: "#2F2E41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.833 30.8921H20.3616V31.3052H105.833V30.8921Z",
    fill: "#2F2E41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.938 46.1138H25.1143V46.5269H100.938V46.1138Z",
    fill: "#2F2E41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3726 17.2578H62.9509V62.499H63.3726V17.2578Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2518 17.2448L79.2249 62.4849L79.6457 62.5119L82.6726 17.2718L82.2518 17.2448Z",
    fill: "#2F2E41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.081 17.2441L43.6602 17.271L46.6695 62.5122L47.0904 62.4853L44.081 17.2441Z",
    fill: "#2F2E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.86aab09726c4c0189e3ff5e5279cdc83.svg";
export { ForwardRef as ReactComponent };